import { createSelector } from "reselect"
import { OwnProps as BookmarkButtonProps } from "./components/BookmarkButton"

const getBookmarks = (
    state: Bookmarks.Bookmarks,
): Record<string, Models.Bookmark> => state.bookmarks

export const getBookmarksArray = createSelector(
    [getBookmarks],
    (bookmarks): Models.Bookmark[] => Object.values(bookmarks),
)

export interface SortedBookmarks {
    sortedBookmarks: Models.Bookmark[]
}

export const getSortedBookmarks = createSelector(
    [getBookmarksArray],
    (bookmarks): SortedBookmarks => ({
        sortedBookmarks: bookmarks.sort((a, b) => a.sequenceNr - b.sequenceNr),
    }),
)

const getFilter = (state: Bookmarks.Bookmarks): string => state.filter

export interface FilteredBookmarks {
    filteredBookmarks: Models.Bookmark[]
}

export const getFilteredBookmarksByTitle = createSelector(
    [getSortedBookmarks, getFilter],
    ({ sortedBookmarks }, filter): FilteredBookmarks => ({
        filteredBookmarks: sortedBookmarks.filter((bookmark) =>
            bookmark.title.toLowerCase().includes(filter.toLowerCase()),
        ),
    }),
)

const getBookmarkButtons = (
    state: Bookmarks.Bookmarks,
    _props: BookmarkButtonProps,
): Record<string, Bookmarks.BookmarkButton> => state.bookmarkButtons

const getBookmarkButtonId = (
    _state: Bookmarks.Bookmarks,
    props: BookmarkButtonProps,
): string => props.bookmarkButtonId

export const getBookmarkButton = createSelector(
    [getBookmarkButtons, getBookmarkButtonId],
    (bookmarkButtons, bookmarkButtonId): Bookmarks.BookmarkButton | null =>
        bookmarkButtons[bookmarkButtonId] ?? null,
)
